import * as React from "react"

import { ServerConfigImage } from "shared/utils/config"

const useFavicon = (image: ServerConfigImage) => {
  React.useEffect(() => {
    let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']")
    if (!link) {
      link = document.createElement("link")
      link.rel = "icon"
      document.head.appendChild(link)
    }
    link.href = image.url
  }, [image.url])
}

export default useFavicon
